import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=2cc83d7d"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=2cc83d7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports